var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "refresh",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.6,
    height: 155.6,
    viewBox: "0 0 155.6 155.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18514",
    "data-name": "Path 18514",
    d: "M77.8,0A77.8,77.8,0,1,1,0,77.8,77.8,77.8,0,0,1,77.8,0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18514_-_Outline",
    "data-name": "Path 18514 - Outline",
    d: "M77.8,4.714A73.086,73.086,0,0,0,26.121,129.479,73.086,73.086,0,0,0,129.479,26.121,72.607,72.607,0,0,0,77.8,4.714M77.8,0A77.8,77.8,0,1,1,0,77.8,77.8,77.8,0,0,1,77.8,0Z",
    transform: "translate(0 0)",
    fill: "#ffd055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22225",
    "data-name": "Path 22225",
    d: "M-394.554,35.4h-1.069q-11.683,0-23.367,0c-4.81,0-7.74-2.9-7.742-7.693q-.016-24.531-.01-49.062c0-4.1,2.225-6.949,5.942-7.636a9.292,9.292,0,0,1,1.667-.109q30.025-.008,60.048,0c2.631,0,4.017,1.375,4.016,4.019,0,1.011-.089,2.022-.137,3.032-.984.037-1.969.105-2.953.106q-28.487.009-56.974.008a9.033,9.033,0,0,0-1.484.078,3.5,3.5,0,0,0-2.943,3.452A3.486,3.486,0,0,0-416.8-14.9a7.026,7.026,0,0,0,1.478.124q28.115.006,56.231,0c2.615,0,4.025,1.382,4.027,4.022q.016,19.271.008,38.542c-.005,4.672-2.984,7.618-7.642,7.621q-11.776.006-23.553,0h-1V11.944c.321.284.569.483.794.707,1.188,1.183,2.359,2.381,3.554,3.555a3.546,3.546,0,0,0,5.222.193,3.53,3.53,0,0,0-.131-5.221Q-382.993,5.958-388.219.783a3.529,3.529,0,0,0-5.362-.015q-5.222,5.179-10.4,10.4a3.521,3.521,0,0,0-.144,5.216,3.526,3.526,0,0,0,5.217-.172c1.411-1.389,2.788-2.812,4.354-4.4Z",
    transform: "translate(468.698 79.509)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralWithdraw);
export default __webpack_public_path__ + "static/media/general-withdraw.efb8464a2750b5f1fd8aa51bf4615176.svg";
export { ForwardRef as ReactComponent };